import F84Game from "../../Game";

export default class ImageOverride {
    /*
     * This tricks phaser into thinking that textures are a different size than they actually are.
     * Allowing us to server different res textures with the exact same layout as our base resolution
     */
    static override(resolution: number): void {

        const r = resolution;
        if (r == 1) return;

        Phaser.Loader.FileTypes.SpriteSheetFile.prototype.addToCache = function (): void {
            const config = <any>this.config; //frame config
            config.frameHeight *= r;
            config.frameWidth *= r;
            const texture = this.cache.addSpriteSheet(this.key, this.data, this.config);
            this.pendingDestroy(texture);
        };

        const snapshot = Phaser.GameObjects.Video.prototype.snapshot;
        Phaser.GameObjects.Video.prototype.snapshot = function(this: Phaser.GameObjects.Video, width?: number, height?: number): Phaser.Textures.CanvasTexture {
            return snapshot.call(this, width / r, height / r);
        };
    }

    static overrideTexture(texture: Phaser.Textures.Texture): void {
        const r = F84Game.Instance.quality.resolution;
        if (r == 1) return;

        Object.entries(texture.frames).forEach((prop) => {
            const frame: Phaser.Textures.Frame = prop[1];
            frame.centerX /= r;
            frame.centerY /= r;
            frame.x /= r;
            frame.y /= r;
            frame.cutX /= r;
            frame.cutY /= r;
            frame.cutHeight /= r;
            frame.cutWidth /= r;
            frame.halfHeight /= r;
            frame.halfWidth /= r;
            frame.height /= r;
            frame.width /= r;
            const data = (<any>frame).data;
            data.cut.b /= r;
            data.cut.h /= r;
            data.cut.r /= r;
            data.cut.w /= r;
            data.cut.x /= r;
            data.cut.y /= r;
            data.drawImage.x /= r;
            data.drawImage.y /= r;
            data.drawImage.width /= r;
            data.drawImage.height /= r;
            data.radius /= r;
            data.sourceSize.w /= r;
            data.sourceSize.h /= r;
            data.spriteSourceSize.x /= r;
            data.spriteSourceSize.y /= r;
            data.spriteSourceSize.w /= r;
            data.spriteSourceSize.h /= r;
            const customData = (<any>frame).customData;
            if (customData.frame) {
                customData.frame.x /= r;
                customData.frame.y /= r;
                customData.sourceSize.w /= r;
                customData.sourceSize.h /= r;
                customData.spriteSourceSize.x /= r;
                customData.spriteSourceSize.y /= r;
                customData.spriteSourceSize.h /= r;
                customData.spriteSourceSize.w /= r;
            }
        });
        texture.source.forEach((source) => {
            source.height /= r;
            source.width /= r;
        });
    }
}
